import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';

@Injectable({
  providedIn: 'root'
})
export class MixpanelTrackingService {
  /**
  * Initialize mixpanel.
  *
  * @param {string} userToken
  * @memberof MixpanelService
  */
  private userInfo: any;
  private appName: string;
  init(): void {
    mixpanel.init("0eb79ba6df583c1a061d28fe419a531d");
    if (mixpanel && mixpanel && mixpanel.track && typeof mixpanel.register === 'function') {
      mixpanel.register({ appName: this.getAppName() });
    }
    this.getIdentity();
    this.setIdentity();
    this.setPerson();
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */

  private setIdentity() {
    if (this.userInfo != null) {
      let username = this.userInfo.Info && this.userInfo.Info.USERNAME ? this.userInfo.Info.USERNAME : this.userInfo.Email;
      mixpanel.identify(username);
    }
  }


  private setPerson() {
    if (mixpanel && mixpanel && mixpanel.people) {
      let personInfo: any;
      var identityData = localStorage.getItem('MLS-IDENTITY');
      try {
        if(identityData != null) {
          personInfo = JSON.parse(identityData);
        }
        else {
          personInfo = { FullName: 'anonymous user', Email: '', AccountKey: 'anonymous', Info: { CLASS: 'public', MYMLS: 'public' } }
        }
      }
      catch (e) {
        localStorage.removeItem('MLS-IDENTITY');
        return;
      }

      var name = personInfo.FullName.split(' ');
      if (personInfo.IdentityType == 'contact') {
        mixpanel.people.set({
          '$first_name': name[0], '$last_name': name[1],
          '$email': personInfo.Email, 'Id': personInfo.AccountKey
        });
      } else {
        mixpanel.people.set({
          '$first_name': name[0], '$last_name': name[1],
          '$email': personInfo.Email, 'member_class': personInfo.Info.CLASS, 'mlsId': personInfo.Info.MYMLS
        });
      }
    }
  }
  getAppName() {
    if (this.appName == "") {
      throw "App name is not setup, please set your application name before initialize";
    }
    return this.appName;
  }
  setAppName(val: string) {
    this.appName = val;
  }
  registerAppName() {
    if (mixpanel && mixpanel && mixpanel.track && typeof mixpanel.register === 'function') {
      mixpanel.register({ appName: this.getAppName() });
    }
  }

  getIdentity() {
    if (typeof (Storage) !== 'undefined') {
      var identityData = localStorage.getItem('MLS-IDENTITY');
      try {
        if (identityData != null)
          this.userInfo = JSON.parse(identityData);
        else
          this.userInfo = { Email: '', FullName: 'anonymous user' }
      }
      catch (e) {
        localStorage.removeItem('MLS-IDENTITY');
        this.userInfo = { Email: '', FullName: '' }
      }
    }
    else
      this.userInfo = { Email: '', FullName: '' };
  }
  public  trackMixPanelEvent(eventCategory :string, json : Object , callback : Function) {
    if (mixpanel && mixpanel && mixpanel.track && typeof mixpanel.track === 'function') {
      mixpanel.track(eventCategory, json);
    }
    var callbackType = typeof callback;
    if (callbackType != typeof undefined && callbackType == "function") {
      callback();
    }
  }
}
